import { Component, ViewChild, NgModule } from '@angular/core';

import { FicheGeneriqueComponent, BarreMenusComponent, DonneesMenuItem } from '../../../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import { RetournerVueVenteResultat } from '../../../RetournerVueVenteResultat';
import { VueFactureVenteFicheContenuComponent } from '../vue-facture-vente-fiche-contenu/vue-facture-vente-fiche-contenu.component';

//Composant fiche de la facture de vente - Modal
@Component(
  {
    selector: 'val-facture-vente-fiche',
    imports:[
      BarreMenusComponent,
      FicheGeneriqueComponent,
      VueFactureVenteFicheContenuComponent
    ],
    templateUrl: './vue-facture-vente-fiche.component.html',
    styleUrls: ['./vue-facture-vente-fiche.component.scss']
  })
export class VueFactureVenteFicheComponent {
  
  // Fiche générique
  @ViewChild("ficheGenerique")
  public ficheGenerique!: FicheGeneriqueComponent<RetournerVueVenteResultat>;

  // Composant contenu réutilisable
  @ViewChild("ficheContenu")
  public ficheContenu!: VueFactureVenteFicheContenuComponent;

  // Ouvre la fiche de consultation de la facture de vente
  // Paramètres
  //  id : Identifiant de la vente
  // Retourne
  //    Données de consultation de la vente
  public async Ouvrir(id: string): Promise<RetournerVueVenteResultat> {
    // Charger les données via le composant contenu
    await this.ficheContenu.ChargerDonnees(id);

    const operation = this.ficheGenerique.Ouvrir();
    return operation;
  }

  // Ferme la fiche de consultation de la facture de vente  
  public Fermer(): void {
    this.ficheGenerique.Fermer();
  }
  
  // Les données du menu
  public menuItems(): DonneesMenuItem[] {
    return this.ficheContenu?.menuItems && !this.ficheContenu.AucuneDonnee() ? this.ficheContenu.menuItems : [];
  }
}
